import { Actions } from '../actions/Actions';
import { crumble as addTrackingEvent } from '../actions/AddTrackingEvent';
import { crumble as activateComplete } from '../actions/completions/ActivateComplete';
import { crumble as initializeComplete } from '../actions/completions/InitializeComplete';
import { crumble as taskFailed } from '../actions/completions/TaskFailed';
import { crumble as featureFlagsChanged } from '../actions/FeatureFlagsChanged';
import { crumble as networkChanged } from '../actions/NetworkChanged';
import { crumble as selectBorer } from '../actions/SelectBorer';
import { Bakery, Crumble, noCrumbs } from './Bakery';
import { Crumbs } from './Crumbs';

export const actionBakery: Bakery<Actions> = {
  ActivateComplete: activateComplete,
  AddTrackingEvent: addTrackingEvent,
  CleanComplete: noCrumbs,
  Destroy: noCrumbs,
  DestroyComplete: noCrumbs,
  Disable: noCrumbs,
  EventsTracked: noCrumbs,
  FeatureFlagsChanged: featureFlagsChanged,
  InitializeComplete: initializeComplete,
  LogOut: noCrumbs,
  NetworkChanged: networkChanged,
  Rebuild: noCrumbs,
  Restart: noCrumbs,
  SelectBorer: selectBorer,
  Start: noCrumbs,
  StartTask: noCrumbs,
  Stop: noCrumbs,
  SuspendComplete: noCrumbs,
  TaskFailed: taskFailed,
  UpgradeComplete: noCrumbs,
  WipeComplete: noCrumbs,
};

export function crumbleAction<T extends Actions>(action: T): Crumbs {
  // This type assertion is safe because know that `actionBakery` maps the `kind` to the `Crumble` for the `action`.
  const crumble = actionBakery[action.kind] as Crumble<typeof action>;
  return {
    ...crumble(action),
    kind: action.kind,
  };
}
